import React, { useState, useEffect } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { toast, ToastContainer } from "react-toastify";

export default function ReceiptLayoutSettings() {
  const [header, setHeader] = useState("");
  const [footer, setFooter] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [pdfPath, setPdfPath] = useState(""); // State to store the PDF URL
  const [isConfirmed, setIsConfirmed] = useState(false); 

  // 1. Fetch data on load
  useEffect(() => {
    fetchInvoiceLayout();
  }, []);

  const fetchInvoiceLayout = async () => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      language: "en",
    };

    try {
      const response = await simplePostCall(
        ApiConfig.parentintegrationsettingsget,
        JSON.stringify(requestBody),
      );
      if (response?.result && response?.invoice_layout?.length > 0) {
        setHeader(response.invoice_layout[0].invoice_header || "");
        setFooter(response.invoice_layout[0].invoice_footer || "");
      }
    } catch (error) {
      console.error("Error loading layout:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmFinalize = () => {
    setIsConfirmed(true);
    toast.success("PDF confirmed and finalized!");
  };
  // 2. Handle Save and Get PDF Path
  const handleSaveAndPreview = async () => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");
    const user_id = localStorage.getItem("user_id");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      user_id: Number(user_id),
      language: "en",
      invoice_layout: [{ invoice_header: header, invoice_footer: footer }],
    };

    try {
      // Calling the API you mentioned
      const response = await simplePostCall(
        ApiConfig.invoicelayout,
        JSON.stringify(requestBody),
      );

      if (response?.result && response?.path) {
        setShowPreview(false);
        setPdfPath(""); // Set the URL: http://localhost:3000/.../previewTest.pdf
        toast.success("Layout saved! Generating PDF preview...", {
          autoClose: 1500,
        });

        setTimeout(() => {
          setPdfPath(response.path);
          setShowPreview(true);
        }, 1500);
      } else if (response?.result) {
        toast.success("Saved successfully!");
      } else {
        toast.warning("Save completed, but no preview available.");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while saving layout!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="receiplayout-container my-4">
      <ToastContainer />
      <div className="col-md-12">
        <div className="special-header panel-white-all mx-4">
          <h4 className="page-title">Invoice Layout & PDF Review</h4>
        </div>

        <div style={{ marginTop: "10px" }} className="row">
          {/* LEFT SIDE: Editors */}
          <div className="col-lg-6">
            <div className="receip-bg p-3 border rounded shadow-sm bg-white">
              <div className="editor-section mb-4">
                <label className="fw-bold">Header Content</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={header}
                  onChange={(event, editor) => setHeader(editor.getData())}
                />
              </div>

              <div className="editor-section mb-4">
                <label className="fw-bold">Footer Content</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={footer}
                  onChange={(event, editor) => setFooter(editor.getData())}
                />
              </div>

              <button
                className="btn custom-btn w-100"
                onClick={handleSaveAndPreview}
                disabled={isLoading}
              >
                {isLoading
                  ? "Generating PDF..."
                  : "Save & Generate PDF Preview"}
              </button>
            </div>
          </div>

          {/* RIGHT SIDE: PDF Review */}
          <div style={{ marginTop: "29px" }} className="col-lg-6">
            <div className="pdf-review-section p-3 border rounded shadow-sm bg-light h-100">
              <h5 className="border-bottom pb-2 mb-3">PDF Review</h5>

              {pdfPath ? (
                <div
                  style={{
                    height: "418px",
                    display: "flex",
                    flexDirection: "column",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    background: "#fff",
                    overflow: "scroll",
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      overflowY: "auto",
                    }}
                  >
                    {showPreview && pdfPath && (
                      <iframe
                        src={`${pdfPath}#toolbar=0&navpanes=0`}
                        width="100%"
                        height="100%"
                        title="Invoice PDF Preview"
                        style={{ border: "none" }}
                      ></iframe>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px",
                      padding: "10px",
                      borderTop: "1px solid #ddd",
                      background: "#fff",
                      flexShrink: 0,
                    }}
                  >
                    <a
                      href={pdfPath}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-outline-primary btn-sm"
                    >
                      Open in New Tab
                    </a>
                    <button
                      className="btn btn-success btn-sm"
                      onClick={handleConfirmFinalize}
                      disabled={isConfirmed}
                    >
                      {isConfirmed ? "Confirmed" : "Confirm & Finalize"}
                    </button>
                  </div>
                </div>
              ) : (
                <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
                  <i
                    className="bi bi-file-pdf"
                    style={{ fontSize: "3rem" }}
                  ></i>
                  <p>Save changes to generate and review PDF</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
